module.exports = {"backend":"http://cellarium.tiits.local","user":"bite","token":"7dfSmG10u60P!t9Xl@teKMxMc5#i5FHy"}


//////////////////
// WEBPACK FOOTER
// ./src/resources/settings/dev.json
// module id = T1Kr
// module chunks = 1